import { createSelector } from 'reselect';
import PaperFreeMonitoringPostDetailsColumns
  from '../../containers/PaperFreeMonitoringPostDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PaperFreeMonitoringDetailsTotalColumns
  from '../../containers/PaperFreeMonitoringPostDetailsTotalColumns';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PAPER_FREE_MONITORING_POST_902_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PAPER_FREE_MONITORING_POST_902_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PAPER_FREE_MONITORING_POST_902_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PaperFreeMonitoringPostDetailsColumns);

export const getTotalColumns =
  createSelector(getData, PaperFreeMonitoringDetailsTotalColumns);
